import { TextField } from '@mui/material';
import T from '../text';

export const FormikTextAreaView = ({
  name,
  label,
  disabled,
  focused,
  minWidth = '100%',
  className,
  formik,
  ...other
}) => {
  return (
    <TextField
      label={<T>{label}</T>}
      name={name}
      disabled={disabled}
      focused={focused}
      onChange={formik.handleChange}
      onBlur={formik.handleBlur}
      value={formik.values[name]}
      error={formik.touched[name] && Boolean(formik.errors[name])}
      helperText={formik.touched[name] && formik.errors[name]}
      className={className}
      sx={{ minWidth: minWidth }}
      multiline
      {...other}
    />
  );
};
